export default __webpack_public_path__ + "static/media/accounting_point_9_kr.e3b9a913.png";